import { render, staticRenderFns } from "./ProfesionalABM.vue?vue&type=template&id=1d12050e&scoped=true"
import script from "./ProfesionalABM.vue?vue&type=script&lang=js"
export * from "./ProfesionalABM.vue?vue&type=script&lang=js"
import style0 from "./ProfesionalABM.vue?vue&type=style&index=0&id=1d12050e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/msuarez/PycharmProjects/terrada-front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d12050e",
  null
  
)

export default component.exports